import * as React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { fetchingAllUseCase, fetchingBeforePackExpiry } from "../redux/Actions";
import { useDispatch } from 'react-redux'
import { useEffect } from 'react';

export default function Buttons(props) {
  const dispatch = useDispatch()
  const submitdata=()=>{
    if(props?.type=="accordiasubmit"){
       dispatch(fetchingBeforePackExpiry(props?.data))

       setTimeout(() => {
        dispatch(fetchingAllUseCase());
      }, 500);
    }
  }

  return (
    <Stack direction="row" spacing={2}>
      <Button disabled ={props.disabled} className='__butn' variant="contained" onClick={() => {
    submitdata()
  }}>{props?.name}</Button>
    </Stack>
  );
}